export default "__VITE_ASSET__C9j9Kf$O__"